// extracted by mini-css-extract-plugin
export default {"main-page-not-found":"workInProgress_main-page-not-found__wITBg","work-in-progress-image":"workInProgress_work-in-progress-image__yRAtc"};